import { createAction } from '@reduxjs/toolkit';
export const openModalAction = createAction('openModal');
export const closeModalAction = createAction('closeModal');